import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import RTL from "../views/Rtl.vue";
import Notifications from "../views/Notifications.vue";
import Profile from "../views/Profile.vue";
import SignIn from "../views/SignIn.vue";
import SignUp from "../views/SignUp.vue";
import Students from "../views/Students/Students.vue";
import GradeFinalization from "../views/GradeFinalization/GradeFinalization.vue";
import InvoiceManagement from "../views/InvoiceManagement/InvoiceManagement.vue";
import InvoiceList from "../views/InvoiceList/InvoiceList.vue";
import FeeTypeManagement from "../views/FeeTypeManagement/FeeTypeManagement.vue";
import TeacherAssignments from "../views/TeacherAssignments/TeacherAssignments.vue";
import FeeStructureManagement from "../views/FeeStructureManagement/FeeStructureManagement.vue";
import GradingScaleManagement from "../views/GradingScaleManagement/GradingScaleManagement.vue";
import PromotionManagement from "../views/PromotionManagement/PromotionManagement.vue";
import FinalRecordViewer from "../views/FinalRecordViewer/FinalRecordViewer.vue";
import StudentFinalTranscriptViewer from "../views/StudentFinalTranscriptViewer/StudentFinalTranscriptViewer.vue";
import GradingScale from "../views/GradingScales/GradingScale.vue";
import ScoreEntry from "../views/ScoreEntry/ScoreEntry.vue";
import StudentEnrollments from "../views/StudentEnrollments/StudentEnrollments.vue";
import Grade from "../views/Grade/Grade.vue";
import TeacherAssessment from "../views/TeacherAssessment/TeacherAssessment.vue";
import TeacherAssignment from "../views/TeacherAssignment/TeacherAssignment.vue";
import AssessmentTypeManagement from "../views/AssessmentTypeManagement/AssessmentTypeManagement.vue";
import CurriculumSetup from "../views/CurriculumSetup/CurriculumSetup.vue";
import GradingPolicyManagement from "../views/GradingPolicyManagement/GradingPolicyManagement.vue";
import AssessmentManagement from "../views/AssessmentManagement/AssessmentManagement.vue";
import NotificationSender from "../views/NotificationSender/NotificationSender.vue";
import UserNotification from "../views/UserNotification/UserNotification.vue";
import Stories from "../views/Stories/Stories.vue";
import RegisterUsers from "../views/RegisterUsers/RegisterUsers.vue";
import AnnouncementSender from "../views/AnnouncementSender/AnnouncementSender.vue";
import SendEmails from "../views/SendEmails/SendEmails.vue";
import GradeLevel from "../views/GradeLevel/GradeLevel.vue";
import ReportCardTemplateManagement from "../views/ReportCardTemplateManagement/ReportCardTemplateManagement.vue";
import EmployeeHourSalary from "../views/EmployeeHourSalary/EmployeeHourSalary.vue";
import AttendanceHourEmployee from "../views/AttendanceHourEmployee/AttendanceHourEmployee.vue";
import DeductionPerHour from "../views/DeductionPerHour/DeductionPerHour.vue";
import IssuedSalariesPerHour from "../views/IssuedSalariesPerHour/IssuedSalariesPerHour.vue";
import Treasury from "../views/Treasury/Treasury.vue";
import Parents from "../views/Parents/Parents.vue";
import Salaries from "../views/Salaries/Salaries.vue";
import EventsCalendar from "../views/EventsCalendar/EventsCalendar.vue";
import AbsenceDeduction from '../views/AbsencesDeduction/AbsenceDeduction.vue';
import ManageSalaries from "../views/ManageSalaries/ManageSalaries.vue";
import Users from "../views/Users/Users.vue";
import Attendances from "../views/Attendances/StudentAttendances.vue";
import Employees from "../views/Employees/Employees.vue";
import PermissionEmployee from "../views/PermissionEmployee/PermissionEmployee.vue";
import EmployeeType from "../views/EmployeeType/EmployeeType.vue";
import EmployeeDetails from "../views/EmployeeDetails/EmployeeDetails.vue";
import SummerCamp from "../views/SummerCamp/SummerCampAdd.vue";
import SummerCampData from "../views/SummerCamp/SummerCampData.vue";
import Classes from "../views/Classes/Classes.vue";
import Term from "../views/Term/Term.vue";
import Subject from "../views/Subject/Subject.vue";
import TeacherSubject from "../views/TeacherSubject/TeacherSubject.vue";
import TeacherSubjectShow from "../views/TeacherSubject/TeacherSubjectShow.vue";
import SubjectCategory from "../views/SubjectCategory/SubjectCategory.vue";
import Departments from "../views/Departments/Departments.vue";
import SchoolSchedule from "../views/SchoolSchedule/SchoolSchedule.vue";
import TeacherType from "../views/TeacherType/TeacherType.vue";
import ClassesSections from "../views/ClassesSections/ClassesSections.vue";
import StudentsCards from '../views/StudentsCards/StudentsCards.vue';
import ReportCardViewer from '../views/ReportCardViewer/ReportCardViewer.vue';
import ParentManagement from '../views/ParentManagement/ParentManagement.vue';
import VendorManagement from '../views/Vendor/VendorManagement.vue';
import ChartOfAccounts from '../views/ChartOfAccounts/ChartOfAccounts.vue';
import BillManagement from '../views/Bills/BillManagement.vue';
import FinancialReports from '../views/FinancialReports/FinancialReports.vue';
import SalaryShow from '../views/SalaryShow/SalaryShow.vue';
import LogsCheck from '../views/LogsCheck/LogsCheck.vue';
import SubscriptionFee from '../views/SubscriptionFee/SubscriptionFee.vue';
import ParentWithStudentsForm from '../views/ParentWithStudentsForm/ParentWithStudentsForm.vue';
import TreasuryTransactions from '../views/TreasuryTransactions/TreasuryTransactions.vue';
import Prediction from '../views/Prediction/Prediction.vue';
import FinancialDocument from '../views/FinancialFees/FinancialDocument.vue';
import ReportCard from '../views/ReportCard/ReportCard.vue';
import TimeTable from '../views/TimeTable/TimeTable.vue';
import FinancialDocumentPrint from '../views/FinancialDocumentPrint/FinancialDocumentPrint.vue';
import ImportAttendance from '../views/ImportAttendance/ImportAttendance.vue';
import HealthFile from '../views/HealthFile/HealthFile.vue';
import AllHealthFiles from '../views/HealthFile/AllHealthFiles.vue';
import ActivityLog from '../views/ActivityLog/ActivityLog.vue';
import ParentWallet from '../views/ParentWallet/ParentWallet.vue';
import StudentIdCards from '../views/StudentIdCards/StudentIdCards.vue';
import LostItemDashboard from '../views/LostItemDashboard/LostItemDashboard.vue';
import Exams from "../views/Exams/Exams.vue";
import Buses from "../views/Buses/Buses.vue";
import kitchen from "../views/kitchen/kitchen.vue";
import NotFound from "../views/NotFound/NotFound.vue";
import ExtraEmployeeData from "../views/ExtraEmployeeData/ExtraEmployeeData.vue";
import TeacherManagement from "../views/TeacherManagement/TeacherManagement.vue";
import SupervisorManagement from "../views/SupervisorManagement/SupervisorManagement.vue";
import kitchenSales from "../views/kitchen/kitchenSales.vue";
import ParentFinancialProfile from "../views/ParentFinancialProfile/ParentFinancialProfile.vue";
import allKitchenBills from "../views/kitchen/allKitchenBills.vue";
import VerifyParentIdentity from "../views/SuperVisors/VerifyParentIdentity.vue";
import SiblingDiscountManagement from "../views/SiblingDiscountManagement/SiblingDiscountManagement.vue";

import studentRestrictedMeals from "../views/kitchen/studentRestrictedMeals.vue";
import StudentPurchaseLimit from "../views/kitchen/StudentPurchaseLimit.vue";

import StudyYear from "../views/StudyYear/StudyYear.vue";


import StudentReport from "../views/StudentReport/StudentReport.vue";
import EmployeeReport from "../views/EmployeeReport/EmployeeReport.vue";
import AssignSubjects from "../views/AssignSubjects/AssignSubjects.vue";
import EmployeeWallets from "../views/Walets/EmployeeWallets.vue";
import store from "../store"; // Import Vuex store
import AttendanceInterface from "../views/Attendance/AttendanceInterface.vue";
import AttendanceInterfaceList from "../views/Attendance/AttendanceInterfaceList.vue";
import GenerateGroups from "../views/CommunicationsInterfaces/GenerateGroups.vue";
import AcademicSchedule from "../views/AcademicSchedule/AcademicSchedule.vue";
import ScheduleSettings from "../views/AcademicSchedule/ScheduleSettings.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [

    {
      path: "/",
      name: "Dashboard",
      component: Dashboard,
         meta: { 
          requiresAuth: true 
          ,allowedRoles: ["moder","hr","prin","financial","doctor","admin","student_m","cashier","teacher","student supervisor","developer"]
         }, // Add meta field for authentication requirement
    }, 
   
    {
      path: "/academic-schedule",
      name: "AcademicSchedule",
      component: AcademicSchedule,
      meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, 
    },
    {
      path: "/academic-schedule/settings",
      name: "ScheduleSettings",
      component: ScheduleSettings,
      meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, 
    },
    
    
    {
      path: "/send-emails",
      name: "sendEmails",
      component: SendEmails,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial","developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/attendance",
      name: "AttendanceInterface",
      component: AttendanceInterface,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial","teacher","developer"]}, // Add meta field for authentication requirement
    },{
      path: "/attendance-list",
      name: "AttendanceInterfaceList",
      component: AttendanceInterfaceList,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial","teacher", "developer"]}, // Add meta field for authentication requirement
    },
    
    {
      path: "/parent-student-form",
      name: "ParentWithStudentsForm",
      component: ParentWithStudentsForm,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial","teacher", "developer"]}, // Add meta field for authentication requirement
    },

    
    
    {
      path: "/events-calendar",
      name: "EventsCalendar",
      component: EventsCalendar,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/employee-hour-salary",
      name: "EmployeeHourSalary",
      component: EmployeeHourSalary,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/attendance-hour-employee",
      name: "AttendanceHourEmployee",
      component: AttendanceHourEmployee,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/deduction-per-hour",
      name: "DeductionPerHour",
      component: DeductionPerHour,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/issued-salaries-per-hour",
      name: "IssuedSalariesPerHour",
      component: IssuedSalariesPerHour,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/study-years",
      name: "StudyYear",
      component: StudyYear,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/terms",
      name: "Term",
      component: Term,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/student-enrollments",
      name: "StudentEnrollments",
      component: StudentEnrollments,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/grade-levels",
      name: "GradeLevel",
      component: GradeLevel,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/grade-scales",
      name: "GradingScale",
      component: GradingScale,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/grades",
      name: "Grade",
      component: Grade,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/grading-scale-management",
      name: "GradingScaleManagement",
      component: GradingScaleManagement,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/promotion-management",
      name: "PromotionManagement",
      component: PromotionManagement,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/final-record-viewer",
      name: "FinalRecordViewer",
      component: FinalRecordViewer,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/student-final-transcript-viewer",
      name: "StudentFinalTranscriptViewer",
      component: StudentFinalTranscriptViewer,
      meta: { requiresAuth: false, hideLayout: true }, // Add hideLayout flag
    },
    {
      path: "/subject-categories",
      name: "SubjectCategory",
      component: SubjectCategory,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/subjects",
      name: "Subject",
      component: Subject,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/teacher-subjects",
      name: "TeacherSubject",
      component: TeacherSubject,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/teacher-with-subjects",
      name: "TeacherSubjectShow",
      component: TeacherSubjectShow,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin","student_m","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/verify-parent-identity",
      name: "VerifyParentIdentity",
      component: VerifyParentIdentity,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","admin", "developer"]}, // Add meta field for authentication requirement
    },

    
    {
      path: "/employee-type",
      name: "EmployeeType",
      component: EmployeeType,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/health-files",
      name: "HealthFile",
      component: HealthFile,
         meta: { requiresAuth: true,allowedRoles: ["moder","doctor", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/absence-and-deduction",
      name: "AbsenceDeduction",
      component: AbsenceDeduction,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","financial", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/vendors",
      name: "VendorManagement",
      component: VendorManagement,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","financial", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/chart-of-accounts",
      name: "ChartOfAccounts",
      component: ChartOfAccounts,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","financial", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/bills",
      name: "BillManagement",
      component: BillManagement,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","financial", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/financial-reports",
      name: "FinancialReports",
      component: FinancialReports,
         meta: { requiresAuth: true ,allowedRoles: ["moder","hr","prin","financial", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/all-health-files",
      name: "AllHealthFiles",
      component: AllHealthFiles,
         meta: { requiresAuth: true  ,allowedRoles: ["moder","doctor","prin","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/tables",
      name: "Tables",
      component: Tables,
         meta: { requiresAuth: true }, // Add meta field for authentication requirement
    },
    {
      path: "/billing",
      name: "Billing",
      component: Billing,
         meta: { requiresAuth: true }, // Add meta field for authentication requirement
    },
    {
      path: "/buses",
      name: "Buses",
      component: Buses,
         meta: { requiresAuth: true ,allowedRoles: ["moder","student_m","hr","admin", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/print-financial-document",
      name: "PrintFinancialDocument",
      component: FinancialDocumentPrint,
         meta: { requiresAuth: true ,allowedRoles: ["moder","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/import-attendance",
      name: "ImportAttendance",
      component: ImportAttendance,
         meta: { requiresAuth: true ,allowedRoles: ["moder","financial","hr", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/financial-document",
      name: "FinancialDocument",
      component: FinancialDocument,
         meta: { requiresAuth: true ,allowedRoles: ["moder","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/exams",
      name: "Manage Exams",
      component: Exams,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/report-cards",
      name: "ReportCard",
      component: ReportCard,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/timetable",
      name: "TimeTable",
      component: TimeTable,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/announcement-sender",
      name: "AnnouncementSender",
      component: AnnouncementSender,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/register-users",
      name: "RegisterUsers",
      component: RegisterUsers,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/my-assignment",
      name: "TeacherAssessment",
      component: TeacherAssessment,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer","teacher"]}, // Add meta field for authentication requirement
    },
    {
      path: "/parents-account",
      name: "ParentManagement",
      component: ParentManagement,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer","teacher"]}, // Add meta field for authentication requirement
    },
    {
      path: "/teachers-account",
      name: "TeacherManagement",
      component: TeacherManagement,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer","teacher"]}, // Add meta field for authentication requirement
    },
    {
      path: "/supervisor-management",
      name: "SupervisorManagement",
      component: SupervisorManagement,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer","teacher"]}, // Add meta field for authentication requirement
    },
    // هذا ملف خاص لحسابات مستخدمي معلمين
    {
      path: '/teachers/:user/assignments',
      name: "TeacherAssignments",
      component: TeacherAssignments,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer","teacher"]}, // Add meta field for authentication requirement
    },
    {
      path: "/teacher-assignment",
      name: "TeacherAssignment",
      component: TeacherAssignment,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer","teacher"]}, // Add meta field for authentication requirement
    },
    {
      path: "/assessment-type-management",
      name: "AssessmentTypeManagement",
      component: AssessmentTypeManagement,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/grading-policy-management",
      name: "GradingPolicyManagement",
      component: GradingPolicyManagement,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/score-entry",
      name: "ScoreEntry",
      component: ScoreEntry,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer","teacher"]}, // Add meta field for authentication requirement
    },
    {
      path: "/grade-finalization",
      name: "GradeFinalization",
      component: GradeFinalization,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/report-card-template-management",
      name: "ReportCardTemplateManagement",
      component: ReportCardTemplateManagement,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
 
    {
      path: "/curriculum-setup",
      name: "CurriculumSetup",
      component: CurriculumSetup,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/notification-sender-parents",
      name: "NotificationSender",
      component: NotificationSender,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/assessment-management",
      name: "AssessmentManagement",
      component: AssessmentManagement,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/user-notification",
      name: "UserNotification",
      component: UserNotification,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/predictions",
      name: "Prediction",
      component: Prediction,
         meta: { requiresAuth: true }, // Add meta field for authentication requirement
    },
    {
      path: "/classes-sections",
      name: "Classes Sections",
      component: ClassesSections,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/rtl-page",
      name: "RTL",
      component: RTL,
         meta: { requiresAuth: true }, // Add meta field for authentication requirement
    },
    {
      path: "/notifications",
      name: "Notifications",
      component: Notifications,
         meta: { requiresAuth: true }, // Add meta field for authentication requirement
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
         meta: { requiresAuth: true }, // Add meta field for authentication requirement
    },
    {
      path: "/sign-in",
      name: "SignIn",
      component: SignIn,
    },
    {
      path: "/report-cards/view",
      name: "ReportCardViewer",
      component: ReportCardViewer,
      meta: { requiresAuth: false, hideLayout: true }, // Add hideLayout flag
    },
    {
      path: "/students",
      name: "Students",
      component: Students,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/kitchen",
      name: "kitchen",
      component: kitchen,
         meta: { requiresAuth: true ,allowedRoles: ["moder","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/kitchen-sales",
      name: "kitchen sales",
      component: kitchenSales,
         meta: { requiresAuth: true ,allowedRoles: ["moder","cashier", "developer"]}, // Add meta field for authentication requirement
    },

    {
      path: "/employee-wallets",
      name: "EmployeeWallets",
      component: EmployeeWallets,
      meta: { requiresAuth: true ,allowedRoles: ["moder","financial", "developer"]}, // Add meta field for authentication requirement
    },
  {
      path: "/all-kitchen-bills",
      name: "all Kitchen Bills",
      component: allKitchenBills,
      meta: { requiresAuth: true ,allowedRoles: ["moder","cashier", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/student-restricted-meals",
      name: "student Restricted Meals",
      component: studentRestrictedMeals,
      meta: { requiresAuth: true ,allowedRoles: ["moder","financial","student_m","doctor","hr", "developer"]}, // Add meta field for authentication requirement
    },

    {
      path: "/student-purchase-limit",
      name: "Student Purchase Limit",
      component: StudentPurchaseLimit,
      meta: { requiresAuth: true ,allowedRoles: ["moder","financial","student_m","hr", "developer"]}, // Add meta field for authentication requirement
    },
    
    {
      path: "/treasury-transactions",
      name: "Treasury Transactions",
      component: TreasuryTransactions,
         meta: { requiresAuth: true ,allowedRoles: ["moder", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/parent-wallet",
      name: "ParentWallet",
      component: ParentWallet,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/student-id-cards",
      name: "StudentIdCards",
      component: StudentIdCards,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/lost-item-dashboard",
      name: "LostItemDashboard",
      component: LostItemDashboard,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","financial", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/student-report",
      name: "StudentReport",
      component: StudentReport,
         meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder","student_m", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/employee-reports",
      name: "EmployeeReport",
      component: EmployeeReport,
         meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder","financial", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/assign-subjects",
      name: "AssignSubjects",
      component: AssignSubjects,
         meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder","financial", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/generate-groups",
      name: "GenerateGroups",
      component: GenerateGroups,
         meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder","financial", "developer","teacher"] }, // Add meta field for authentication requirement
    },
    {
      path: "/stories",
      name: "Stories",
      component: Stories,
         meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder","financial", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/treasury",
      name: "Treasury",
      component: Treasury,
         meta: { requiresAuth: true,allowedRoles: ["moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/activity-log",
      name: "ActivityLog",
      component: ActivityLog,
         meta: { requiresAuth: true,allowedRoles: ["moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/cards-students",
      name: "Students Cards",
      component: StudentsCards,
         meta: { requiresAuth: true,allowedRoles: ["hr", "student_m","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/salary-show",
      name: "Salary Employee",
      component: SalaryShow,
         meta: { requiresAuth: true,allowedRoles: ["hr", "financial","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/subscription-fee",
      name: "Subscription Fees",
      component: SubscriptionFee,
         meta: { requiresAuth: true,allowedRoles: ["hr", "financial","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/fee-type-management",
      name: "FeeTypeManagement",
      component: FeeTypeManagement,
         meta: { requiresAuth: true,allowedRoles: ["hr", "financial","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/fee-structure-management",
      name: "FeeStructureManagement",
      component: FeeStructureManagement,
         meta: { requiresAuth: true,allowedRoles: ["hr", "financial","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/parent-financial-profile",
      name: "ParentFinancialProfile",
      component: ParentFinancialProfile,
         meta: { requiresAuth: true,allowedRoles: ["hr", "financial","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/sibling-discount-management",
      name: "SiblingDiscountManagement",
      component: SiblingDiscountManagement,
         meta: { requiresAuth: true,allowedRoles: ["hr", "financial","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/invoice-management",
      name: "InvoiceManagement",
      component: InvoiceManagement,
         meta: { requiresAuth: true,allowedRoles: ["hr", "financial","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/invoice-list",
      name: "InvoiceList",
      component: InvoiceList,
         meta: { requiresAuth: true,allowedRoles: ["hr", "financial","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/logs-checks",
      name: "Show Log Checks",
      component: LogsCheck,
         meta: { requiresAuth: true ,allowedRoles: ["hr", "financial","moder", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/users",
      name: "Users",
      component: Users,
         meta: { requiresAuth: true,allowedRoles: ["moder", "developer"]  }, // Add meta field for authentication requirement
    },
    {
      path: "/parents",
      name: "Parents",
      component: Parents,
         meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder","student_m", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/salaries",
      name: "Salary Management",
      component: Salaries,
         meta: { requiresAuth: true,allowedRoles: [ "financial","moder","hr", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/manage-salaries",
      name: "Manage Salaries",
      component: ManageSalaries,
         meta: { requiresAuth: true ,allowedRoles: [ "financial","moder","hr", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/sign-up",
      name: "SignUp",
      component: SignUp,
         meta: { requiresAuth: true }, // Add meta field for authentication requirement
    },
    {
      path: "/classes",
      name: "classes",
      component: Classes,
      meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder","student_m", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/departments",
      name: "departments",
      component: Departments,
      meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/teachers-type-subject",
      name: "TeacherType",
      component: TeacherType,
      meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/school-schedule",
      name: "SchoolSchedule",
      component: SchoolSchedule,
      meta: { requiresAuth: true }, // Add meta field for authentication requirement
    },
    {
      path: "/permission-employee",
      name: "PermissionEmployee",
      component: PermissionEmployee,
      meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/employees",
      name: "Employees",
      component: Employees,
      meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/employee-details",
      name: "EmployeeDetails",
      component: EmployeeDetails,
      meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/summer-camp-data",
      name: "SummerCampData",
      component: SummerCampData,
      meta: { requiresAuth: true ,allowedRoles: ["hr", "prin","moder", "developer"]}, // Add meta field for authentication requirement
    },
    {
      path: "/summer-camp-add",
      name: "SummerCamp",
      component: SummerCamp,
      meta: { requiresAuth: true,allowedRoles: ["hr", "prin","moder", "developer"] }, // Add meta field for authentication requirement
    },
    {
      path: "/student-attendances",
      name: "Student Attendances",
      component: Attendances,
      meta: { requiresAuth: true, allowedRoles: ["hr", "prin","moder","teacher","student_m", "developer"] }, // accessible by 'hr' or 'admin'
    },
    {
      path: "/get-the-hell-out",
      name: "NotFound",
      component: NotFound,
      meta: { requiresAuth: false}, 
    },
    {
      path: "/employee-form",
      name: "ExtraEmployeeData",
      component: ExtraEmployeeData,
      meta: { requiresAuth: false}, 
    },
    // {
    //   path: "/test-test",
    //   name: "Student Attendances",
    //   component: Attendances,
    //   meta: {
    //     store: store, // Ensure Vuex store is attached to meta
    //   },
    //   beforeEnter: (to, from, next) => {
    //     // Check if Vuex store is attached to route meta
    //     if (to.meta && to.meta.store) {
    //       to.meta.store.dispatch('hideAllElements');
    //     } else {
    //       console.error('Vuex store not attached to route meta!');
    //     }
    //     next();
    //   },
    // },
    {
      path: "/:catchAll(.*)",
      redirect: "/",
    },

  ],
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  
  if (from.name === 'Attendances' && from.meta && from.meta.store) {
    from.meta.store.dispatch('showAllElements');
  }
  next();
});


// Add navigation guard to check for token
// Navigation guard to check authentication and authorization
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const token = localStorage.getItem("access_token");
  const userType = localStorage.getItem("user_type");
 

  if (requiresAuth && !token) {
    return next({ name: "SignIn" });
  }

  if (to.meta.allowedRoles && !to.meta.allowedRoles.includes(userType)) {
    store.commit("setDisplayVisibility", false); // Hide layout elements on 404
    return next({ name: "NotFound" });
  }
  if (to.meta.allowedRoles && !to.meta.allowedRoles.includes(userType)) {
    store.commit("setDisplayVisibility", false); // Hide layout elements on 404
    return next({ name: "ExtraEmployeeData" });
  }

  // Set display visibility based on hideLayout meta field
  const shouldHideLayout = to.matched.some(record => record.meta.hideLayout);
  
  // If user is authenticated and route requires auth, show all elements
  if (requiresAuth && token && !shouldHideLayout) {
    // Force show all elements
    store.commit("SHOW_ALL");
    store.dispatch("showAllElements");
  } else if (shouldHideLayout) {
    // Hide elements for routes that don't need layout
    store.commit("setDisplayVisibility", false);
  } else if (token) {
    // If user has token but route doesn't require auth, still show elements
    store.commit("SHOW_ALL");
  }
  
  next();
});


export default router;
